<template>
    <div>
        <v-dialog persistent v-model="leadFormListOverlay" content-class="leadForm-list-con" :overlay-opacity="opacity">
            <div class="header flex">
                <div class="flex">
                    <v-icon @click="handleBackBtn()" class="icon" color="#1F8F58" size="25"> mdi-arrow-left </v-icon>
                    <h3 class="header-text">Select a form from here</h3>
                </div>
                <v-btn @click="createNewForm" class="addNewForm" size="25" elevation="0" color="#1D8D56"> + Create a New form </v-btn>
            </div>
            <div v-if="loading" class="loader">
                <v-progress-circular :size="100" :width="8" color="#6FB793" indeterminate></v-progress-circular>
            </div>
            <div class="nodata-msg" v-else-if="!loading && totalFormCount === 0">
                <p>No Form present.</p>
            </div>
            <div v-else @scroll="onScroll" class="list-con">
                <div v-for="(form, index) in formList" :key="index">
                    <div :class="{active: form.form_id === selectedFormId}" @click="selectForm(form.form_id)" class="flex list-section">
                        <div class="flex">
                            <img :src="form.image ? form.image.original : defaultImage" alt="" />
                            <div>
                                <h4 class="secondary-font">{{ form.name }}</h4>

                                <div class="flex" style="text-align: center; color: #3A6ACA9; justify-content: flex-start">
                                    <small v-if="form.user" style="color: #727b76">by {{ form.user.full_name }} </small>
                                    <small style="color: #727b76" class="mx-3">
                                        <time-ago :refresh="60" :datetime="form.published_at" long />
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="form-action">
                            <button @click="selectForm(form.form_id)" class="formBtn --green mr-2" style="background: rgba(49, 138, 54, 0.05)">Select this form</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- button section  -->
            <div class="button-section flex">
                <v-btn @click="handleDiscardBtn()" elevation="0" class="cancel-btn" color="#EBF5F0"> Cancel </v-btn>
                <v-btn @click="handleNextBtn" elevation="0" :disabled="selectedFormId == ''" class="next-btn" color="#1D8D56"> Next </v-btn>
            </div>
        </v-dialog>

        <!-- lead form generation flow  -->
        <lead-form
            :cardSize="cardSize"
            :data="data"
            ref="createFormRef"
            :dialog="leadFormOverlay"
            @closeLeadFormOverlay="closeLeadFormOverlay"
            @closeAll="closeAll"
            @reloadApi="reloadApi"
        />

        <div v-if="createAdOverlay">
            <create-advertisement
                :cardSize="cardSize"
                :data="dataforApi"
                :createAdOverlay="createAdOverlay"
                @closeCreateAdOverlay="closeCreateAdOverlay"
                @cancelAdCreation="handleDiscardBtn()"
                @closeAll="reloadApi"
            />
        </div>
    </div>
</template>

<script>
import {TimeAgo} from "vue2-timeago";
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import leadForm from "./lead-form.vue";
import createAdvertisement from "./create-advertisement.vue";
export default {
    name: "leadFormList",
    components: {
        "time-ago": TimeAgo,
        "lead-form": leadForm,
        "create-advertisement": createAdvertisement,
    },
    data() {
        return {
            leadFormOverlay: false,
            createAdOverlay: false,
            formList: [],
            opacity: 0,
            defaultImage: require("../../../../assets/MainDashboard/ActiveLeads/FormListDefault.svg"),
            dataforApi: this.data,
            selectedFormId: "",
            loading: true,
            creator_type: "brand",
            creator_id: "",
            totalFormCount: 0,
            pageno: 1,
        };
    },
    mounted() {
        this.getFormList();
    },
    props: {
        leadFormListOverlay: Boolean,
        selectedCompanyID: String,
        data: Object,
        cardSize: Array,
    },
    watch: {
        leadFormListOverlay: function () {
            console.log("leadFormListOverlay", this.selectedCompanyID);
        },
    },
    methods: {
        selectForm(formId) {
            console.log("FORM", formId);
            this.selectedFormId = formId;
            this.dataforApi.form = formId;
        },

        onScroll({target: {scrollTop, clientHeight, scrollHeight}}) {
            if (scrollTop + clientHeight + 1 >= scrollHeight) {
                if (this.pageno * 10 <= this.totalFormCount) {
                    this.pageno = this.pageno + 1;
                    this.getFormList();
                }
            }
        },

        // close the current overlay on clicking back btn
        handleBackBtn() {
            this.$emit("closeLeadFormListOverlay");
        },

        // open lead form component
        createNewForm() {
            this.$refs.createFormRef.getFormConfigs();
            this.leadFormOverlay = true;
        },
        closeCreateAdOverlay() {
            this.createAdOverlay = false;
        },
        handleDiscardBtn() {
            if (this.createAdOverlay) this.createAdOverlay = false;
            this.$emit("closeAll");
        },
        handleNextBtn() {
            this.createAdOverlay = true;
        },

        closeLeadFormOverlay() {
            this.leadFormOverlay = false;
        },
        reloadApi() {
            this.$emit("reloadApi");
        },
        closeAll() {
            this.$emit("closeAll");
        },
        getFormList() {
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.loading = false;
                    console.log("FORM RESPONSE-->", response.data);
                    this.totalFormCount = response.data.total_data;

                    response.data.form_list.map((item) => {
                        this.formList.push(item);
                    });
                }
            };
            const errorHandler = (response) => {
                this.loading = false;

                this.showToast("Something went wrong internally!", "error", 10000);
            };
            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "business-id": this.selectedCompanyID,
            };
            this.requestGETwithoutHeader(
                `${API_URL.createContent_leadFormList}?page=${this.pageno}&data_per_page=${10}&creator_type=${this.creator_type}&creator_id=${this.selectedCompanyID}`,
                {},
                headers,
                successHandler,
                errorHandler
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    justify-content: space-between;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    background-color: white;
    height: 50px;
    margin-top: 25px;
    margin-bottom: 5px;
}
.header-text {
    font-weight: 500;
    font-size: 1.2rem;
    color: #333333;
    margin-left: 15px;
}
.icon {
    background-color: #eff6f3;
    padding: 8px;
    border-radius: 6px;
}
.addNewForm {
    color: #fff !important;
    height: 44px !important;
    border-radius: 8px;
    cursor: pointer;
    margin-left: 10px;
    text-transform: capitalize !important;
    font-size: 15px !important;
    font-weight: 500;
}
.list-con {
    height: 480px;
    overflow-y: scroll;
    overflow-x: hidden;
    align-content: start;
}
.list-section {
    justify-content: space-between;
    border-radius: 5px;
    border: 0.5px solid #cfcfcf;
    border-radius: 6px;
    padding: 10px 15px;
    margin-top: 10px;

    &.active {
        h3 {
            color: #1d8d56;
            font-weight: 600;
        }
        border: 1.5px solid #1d8d56;
    }
}

.list-section > div:nth-child(2) img {
    background: linear-gradient(0deg, #eff6f3, #eff6f3);
    border-radius: 5px;
}

.formBtn {
    padding: 12px 15px;
    font-size: 0.8rem;
    justify-content: center;
    height: 51px;
    border-radius: 7px;
}

img {
    width: 50px;
    height: 50px;
    margin-right: 15px;
    object-fit: cover;
    border-radius: 7px;
    margin-left: auto;
}

// button section
.button-section {
    justify-content: space-between;
    margin-top: 10px;
    // padding-bottom: 25px;
    // position: sticky;
    // bottom: 0px;
    // background-color: #fff;
    .v-btn {
        width: 48%;
        height: 56px !important;
        text-transform: capitalize !important;
        font-size: 1.1rem;
    }
}
.cancel-btn {
    color: #1d8d56 !important;
    font-size: 1rem;
}
.next-btn {
    color: #ffffff;
    font-size: 1rem;
}
// scrollbar design
::-webkit-scrollbar {
    width: 9px;
    // border-left: 1px solid rgba(50, 52, 65, 0.1);
    // border-right: 1px solid rgba(50, 52, 65, 0.1);
    margin-left: 100px;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(50, 52, 65, 0.4);
    border: 2px solid transparent;
    background-clip: content-box;
}
::-webkit-scrollbar-track {
    display: none;
}
::-webkit-scrollbar-corner {
    display: none;
    height: 0px;
    width: 0px;
}
.nodata-msg {
    width: 100%;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
}
</style>

<style>
.leadForm-list-con.v-dialog {
    width: 800px;
    background-color: white;
    border-radius: 10px;
    box-shadow: none;
    height: 650px;
    padding-left: 25px;
    padding-right: 25px;
}
.leadForm-list-con .mx-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
}
</style>
